import _ from "lodash/fp";

export const withId = (v: any) => ({ ...v, id: _.uniqueId("") });
export const withIds = (v: any[]) => v.map((v) => withId(v));
